import { Mutations, MutationTypes } from './mutations'
import { State } from './state'
import { ActionContext, ActionTree } from 'vuex'
import { Template, IAppInitInfo, ICustomVariables } from '../types'
export enum ActionTypes {
  ADD_BUILDER = 'SET_BUILDER',
  ADD_PARENT_APP = 'SET_PARENT_APP',
  UPDATE_TEMPLATE = 'UPDATE_TEMPLATE',
  UPDATE_AUTH_INFO = 'UPDATE_AUTH_INFO',
  UPDATE_TOKEN = 'UPDATE_TOKEN',
  UPDATE_RETRY_COUNT = 'UPDATE_RETRY_COUNT',
  UPDATE_CUSTOM_VALUES = 'UPDATE_CUSTOM_VALUES',
}

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1]
  ): ReturnType<Mutations[K]>
} & Omit<ActionContext<State, State>, 'commit'>

export interface Actions {
  [ActionTypes.ADD_BUILDER](
    { commit }: AugmentedActionContext,
    payload: {}
  ): void
  [ActionTypes.ADD_PARENT_APP](
    { commit }: AugmentedActionContext,
    payload: {}
  ): void
  [ActionTypes.UPDATE_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: Template
  ): void
  [ActionTypes.UPDATE_AUTH_INFO](
    { commit }: AugmentedActionContext,
    payload: IAppInitInfo
  ): void
  [ActionTypes.UPDATE_TOKEN](
    { commit }: AugmentedActionContext,
    payload: string
  ): void
  [ActionTypes.UPDATE_RETRY_COUNT](
    { commit }: AugmentedActionContext,
    payload: number
  ): void
  [ActionTypes.UPDATE_CUSTOM_VALUES](
    { commit }: AugmentedActionContext,
    payload: ICustomVariables
  ): void
}

export const actions: ActionTree<State, State> & Actions = {
  [ActionTypes.ADD_BUILDER]({ commit }, payload) {
    commit(MutationTypes.ADD_BUILDER, payload)
  },
  [ActionTypes.ADD_PARENT_APP]({ commit }, payload) {
    commit(MutationTypes.ADD_PARENT_APP, payload)
  },
  [ActionTypes.UPDATE_TEMPLATE]({ commit }, payload) {
    commit(MutationTypes.UPDATE_TEMPLATE, payload)
  },
  [ActionTypes.UPDATE_AUTH_INFO]({ commit }, payload) {
    commit(MutationTypes.UPDATE_AUTH_INFO, payload)
  },
  [ActionTypes.UPDATE_TOKEN]({ commit }, payload) {
    commit(MutationTypes.UPDATE_TOKEN, payload)
  },
  [ActionTypes.UPDATE_RETRY_COUNT]({ commit }, payload) {
    commit(MutationTypes.UPDATE_RETRY_COUNT, payload)
  },
  [ActionTypes.UPDATE_CUSTOM_VALUES]({ commit }, payload) {
    commit(MutationTypes.UPDATE_CUSTOM_VALUES, payload)
  },
}
